export const iconFontAwesomeFilmVideoAudioDescription = (
	<i className="fa-solid fa-audio-description"></i>
);
